import React from 'react';
import Select from 'react-select';
import css from './FieldMultiSelect.module.css';
import { IconSpinner } from '..';

function FieldMultiSelect(props) {
  const {
    input,
    options,
    label,
    isMulti = true,
    disabled = false,
    inProgress,
    onChange,
    customStyles,
  } = props;

  const renderSpinner = inProgress ? (
    <span className={css.loader}>
      <IconSpinner />
    </span>
  ) : null;

  const handleChange = selectedOptions => {
    input.onChange(selectedOptions);
    if (onChange) onChange(selectedOptions);
  };

  const value = isMulti
    ? input.value || []
    : options.find(option => option.value === input.value?.value) || input.value || null;

  return (
    <div className={css.reactSelect}>
      {label && (
        <label>
          {label} {renderSpinner}
        </label>
      )}
      <Select
        value={value}
        onChange={handleChange}
        options={options}
        isMulti={isMulti}
        styles={customStyles}
        isDisabled={disabled}
        components={{
          IndicatorSeparator: () => null,
        }}
      />
    </div>
  );
}

const customStyles = {
  control: (styles, { data, isDisabled, isFocused, isSelected }) => ({
    ...styles,
    backgroundColor: '#fff',
    border: 'solid 1px #ddd',
    boxShadow: 'none',
    borderRadius: '6px',
    minHeight: '46px',
    '&:hover': {
      border: isFocused ? 'solid 1px #e5e5e6' : 'solid 1px #ddd',
    },
  }),
  placeholder: styles => ({
    ...styles,
    position: 'relative',
    bottom: '0px',
  }),
  valueContainer: styles => ({
    ...styles,
    minHeight: '46px',
    padding: '0 10px',
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => ({
    ...styles,
    backgroundColor: isDisabled ? '#ddd' : '#fff',
    color: isDisabled ? '#ccc' : '#313135',
    fontSize: '15px',
    padding: '10px 16px',
    cursor: isDisabled ? 'not-allowed' : 'default',
    '&:hover': {
      backgroundColor: '#eee',
      color: '#000',
    },
  }),
  Input: styles => ({ ...styles, margin: '0px', padding: '0px', maxHeight: 45 }),
  menu: styles => ({
    ...styles,
    backgroundColor: '#fff',
  }),
};

FieldMultiSelect.defaultProps = {
  customStyles,
};

export default FieldMultiSelect;
